// hooks/useOrganisations.js
import { useState, useEffect, useCallback } from "react";
import { organisationService } from "../services/organisationService";
import { toast } from "react-toastify";

export const useOrganisations = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({});

  const fetchOrganisations = useCallback(async () => {
    setLoading(true);
    try {
      const orgs = await organisationService.getAllOrganisations();
      setData(orgs);
    } catch (err) {
      toast.error(err.message || "Failed to load organisations");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrganisations();
  }, [fetchOrganisations]);

  const updateOrganisation = async (orgId, formData) => {
    setActionLoading(prev => ({ ...prev, [orgId]: true }));
    try {
      await organisationService.updateOrganisation(orgId, formData);
      toast.success("Organisation updated successfully");
      await fetchOrganisations();
    } catch (err) {
      toast.error(err.message);
      throw err;
    } finally {
      setActionLoading(prev => ({ ...prev, [orgId]: false }));
    }
  };

  const deleteOrganisation = async (orgId) => {
    try {
      await organisationService.deleteOrganisation(orgId);
      toast.success("Organisation deleted");
      await fetchOrganisations();
    } catch (err) {
      toast.error(err.message);
      throw err;
    }
  };

  const suspendAdmin = async (orgAdminId, reason) => {
    try {
      await organisationService.suspendOrgAdmin(orgAdminId, reason);
      toast.success("Admin suspended");
      await fetchOrganisations();
    } catch (err) {
      toast.error(err.message);
      throw err;
    }
  };

  const reactivateAdmin = async (orgAdminId) => {
    try {
      await organisationService.reactivateOrgAdmin(orgAdminId);
      toast.success("Admin reactivated");
      await fetchOrganisations();
    } catch (err) {
      toast.error(err.message);
      throw err;
    }
  };

  return {
    data,
    loading,
    refresh: fetchOrganisations,
    updateOrganisation,
    deleteOrganisation,
    suspendAdmin,
    reactivateAdmin,
    actionLoading,
  };
};